import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { DASHBOARD_ROLES } from './constants';

// Pages
import Login from './pages/Login';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import WorkOrders from './pages/WorkOrders';
import CreateWorkOrder from './pages/CreateWorkOrder';
import WorkOrderDetail from './pages/WorkOrderDetail';
import AdminPanel from './pages/AdminPanel';
import SystemLogs from './pages/SystemLogs';
import NotFound from './pages/NotFound';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Delegations from './pages/Delegations';

function RequireAuth({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-gray-400">Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function RequireGuest({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navigate to="/" replace />;
  return children;
}

function AppRoutes() {
  const { user, isAdminPanel } = useAuth();

  return (
    <Routes>
      {/* Public */}
      <Route path="/login" element={
        <RequireGuest><Login /></RequireGuest>
      } />
      <Route path="/privacy" element={<PrivacyPolicy />} />

      {/* Protected */}
      <Route path="/" element={
        <RequireAuth><Layout /></RequireAuth>
      }>
        {/* Dashboard — most roles */}
        <Route index element={
          DASHBOARD_ROLES.includes(user?.role)
            ? <Dashboard />
            : <Navigate to="/work-orders" replace />
        } />

        {/* Work Orders */}
        <Route path="work-orders" element={<WorkOrders />} />
        <Route path="work-orders/new" element={<CreateWorkOrder />} />
        <Route path="work-orders/:id" element={<WorkOrderDetail />} />

        {/* Delegations — DSM only */}
        <Route path="delegations" element={<Delegations />} />

        {/* Admin */}
        <Route path="admin" element={
          isAdminPanel()
            ? <AdminPanel />
            : <Navigate to="/" replace />
        } />
        <Route path="admin/logs" element={
          isAdminPanel()
            ? <SystemLogs />
            : <Navigate to="/" replace />
        } />

        {/* Fallback */}
        <Route path="*" element={<NotFound />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}